import React from "react";
const icon = (
  <svg
    width="448"
    height="448"
    viewBox="0 0 448 448"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M384 448C419.3 448 448 419.3 448 384V64C448 28.7 419.3 0 384 0H64C28.7 0 0 28.7 0 64V384C0 419.3 28.7 448 64 448H384ZM224 320C217.3 320 211 317.2 206.4 312.3L102.4 200.3C95.9 193.3 94.2 183.1 98 174.4C101.8 165.7 110.5 160 120 160H328C337.5 160 346.2 165.7 350 174.4C353.8 183.1 352.1 193.3 345.6 200.3L241.6 312.3C237.1 317.2 230.7 320 224 320Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
